module.exports = __webpack_public_path__ + "d664201f/img/search-filter-icon.c4751a52.svg";